import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyB_PC471eayZAEbSDPXMRgkY7yNmzOAJPE",
  authDomain: "khisa-foundation-e485a.firebaseapp.com",
  projectId: "khisa-foundation-e485a",
  storageBucket: "khisa-foundation-e485a.firebasestorage.app",
  messagingSenderId: "376051555769",
  appId: "1:376051555769:web:8d44e2e8b5fd8c6f95ea68",
  measurementId: "G-RQ0M12J61L"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
